import { AxiosResponse } from 'axios';
import mixins from 'vue-typed-mixins';

import { ErrorResponse, PasswordResetRequest, ユーザーApi } from '@/openapi/user';

import UserApiUtility from '@/classes/common/UserApiUtility';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import AlertMixin from '@/mixins/AlertMixin';

export default mixins(AlertMixin, RoutesMixin).extend({
  name: 'PasswordReset',

  data(): {
    request: PasswordResetRequest;
  } {
    return {
      request: {
        jwt: this.$route.params.jwt,
        password: '',
        passwordConfirm: '',
      },
    };
  },

  methods: {
    async resetPassword(): Promise<void> {
      const response: AxiosResponse<void | ErrorResponse> = await UserApiUtility.ogApi(ユーザーApi).resetPassword(
        this.request
      );
      if (this.isValidationErrorResponse(response, 'resetPassword.request.passwordConfirm', 'resetPassword.request.'))
        return;
      window.alert('パスワードを再設定しました');
      this.returnLogin();
    },

    returnLogin(): void {
      this.$router.push(this.routes.Login);
    },
  },
});
